import * as React from "react";
import { cn } from "@/lib/utils";
import { X, ChevronLeft } from "lucide-react";
import { FacebookIcon } from "@/assets/icons/facebook";
import { InstagramIcon } from "@/assets/icons/instagram";
import { LinkedinIcon } from "@/assets/icons/linkedin";
import { YouTubeIcon } from "@/assets/icons/youtube";

type IconButtonVariant =
   | "close"
   | "carousel"
   | "s-carousel"
   | "back"
   | "social-instagram"
   | "social-facebook"
   | "social-linkedin"
   | "social-youtube";

const base = "inline-flex items-center justify-center transition-colors";

const iconButtonMap: Record<IconButtonVariant, string> = {
   close: cn(
      base,
      "w-[1.75rem] h-[1.75rem] rounded-[0.375rem]",
      "text-custom-dark hover:text-custom-dark/70"
   ),

   carousel: cn(
      base,
      "w-[3rem] h-[3rem] rounded-[2.5rem] p-2",
      "bg-custom-white text-custom-dark hover:bg-custom-dark/10"
   ),

   "s-carousel": cn(
      base,
      "w-[2rem] h-[2rem] rounded-[2.5rem] p-2",
      "bg-custom-white text-custom-dark hover:bg-custom-dark/10"
   ),

   back: cn(
      base,
      "w-[3.5rem] h-[3.5rem] rounded-full p-[0.875rem] border",
      "border-custom-dark/10 bg-custom-white",
      "hover:bg-custom-white/60 hover:border-custom-dark"
   ),

   "social-instagram": cn(
      base,
      "w-[2.5rem] h-[2.5rem] rounded-[2rem] border p-[0.33rem]",
      "border-custom-dark/20 text-custom-dark hover:border-custom-dark/70"
   ),
   "social-facebook": cn(
      base,
      "w-[2.5rem] h-[2.5rem] rounded-[2rem] border p-[0.33rem]",
      "border-custom-dark/20 text-custom-dark hover:border-custom-dark/70"
   ),
   "social-linkedin": cn(
      base,
      "w-[2.5rem] h-[2.5rem] rounded-[2rem] border p-[0.33rem]",
      "border-custom-dark/20 text-custom-dark hover:border-custom-dark/70"
   ),
   "social-youtube": cn(
      base,
      "w-[2.5rem] h-[2.5rem] rounded-[2rem] border p-[0.33rem]",
      "border-custom-dark/20 text-custom-dark hover:border-custom-dark/70"
   ),
};

const iconMap: Partial<Record<IconButtonVariant, React.ReactNode>> = {
   close: <X className="w-4 h-4" />,
   carousel: <ChevronLeft className="w-6 h-6 rotate-180" />,
   "s-carousel": <ChevronLeft className="w-6 h-6 rotate-180" />,
   back: <ChevronLeft className="w-6 h-6" />,

   "social-facebook": <FacebookIcon className="w-4 h-4" />,
   "social-instagram": <InstagramIcon className="w-4 h-4" />,
   "social-linkedin": <LinkedinIcon className="w-4 h-4" />,
   "social-youtube": <YouTubeIcon className="w-4 h-4" />,
};

interface IconButtonProps
   extends React.ButtonHTMLAttributes<HTMLButtonElement> {
   variant: IconButtonVariant;
   icon?: React.ReactNode;
}

export function IconButton({
   variant,
   icon,
   className,
   ...props
}: IconButtonProps) {
   const classes = cn(iconButtonMap[variant], className);
   const fullIcon = iconMap[variant];
   console.log("classes", classes);
   console.log("fullIcon", fullIcon);
   return (
      <button type="button" className={classes} {...props}>
         {fullIcon}
      </button>
   );
}
